import useFormWithSchema from "../../../hooks/useFormWithSchema";
import { EmailSchema } from "../../../schemas/emailSchema";
import { useCallback, useEffect, useState } from "react";
import { useAddUpdateEmailTemplate } from "../../../hooks/common/mutation";
import toast, { Toaster } from "react-hot-toast";
import { useGetEmailTemplateById } from "../../../hooks/common/query";
import EmailTemplateCard from "../../../components/card/EmailTemplateCard";
import { useTranslation } from "react-i18next";
import { EMAIL_TEMPLATE_CODES } from "../../../constants/common";
import BackButtonWrapper from "../../../components/button/BackButton/wrapper";

const VisitRequestScheduleTemplate = () => {
  const {
    control,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useFormWithSchema(EmailSchema);

  const { data: emailTemplate, isPending: isEmailTemplateLoading } =
    useGetEmailTemplateById({
      EncryptedId: EMAIL_TEMPLATE_CODES.VISIT_REQUEST_SCHEDULE_TEMPLATE,
    });
  const [htmlContent, setHtmlContent] = useState("");

  const { t } = useTranslation();

  useEffect(() => {
    if (emailTemplate) {
      emailTemplate?.emailSubject &&
        setValue("subject", emailTemplate?.emailSubject);
      setHtmlContent(emailTemplate?.emailContent);
    }
  }, [emailTemplate, setValue]);

  const {
    mutateAsync: AddUpdateEmailTemplate,
    isPending: isAddUpdateEmailTemplateLoading,
  } = useAddUpdateEmailTemplate();

  const onSubmit = useCallback(
    async (data: { subject: string }) => {
      try {
        const body = {
          emailId: EMAIL_TEMPLATE_CODES.VISIT_REQUEST_SCHEDULE_TEMPLATE,
          emailSubject: data.subject,
          emailContent: htmlContent,
        };

        await AddUpdateEmailTemplate(body);
        toast.success(t("emailTemplateUpdated"));
      } catch (error) {
        toast.error(t("somethingWentWrong"));
      }
    },
    [AddUpdateEmailTemplate, htmlContent, t]
  );

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />

      <div className="flex flex-col gap-4 md:gap-8">
        <BackButtonWrapper>
          <h1 className="text-xl md:text-2xl dark:text-white">
            {t("visitRequestScheduleTemplate")}
          </h1>
        </BackButtonWrapper>

        <EmailTemplateCard
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          control={control}
          errors={errors}
          htmlContent={htmlContent}
          setHtmlContent={setHtmlContent}
          isEmailTemplateLoading={isEmailTemplateLoading}
          isAddUpdateEmailTemplateLoading={isAddUpdateEmailTemplateLoading}
        />
      </div>
    </>
  );
};

export default VisitRequestScheduleTemplate;
